import styled from 'styled-components';
import { func, shape, string } from 'prop-types';

import SideMenuWrapper from './SideMenuWrapper';
import StyledIcon from '../shared/StyledIcon';
import AppMenu from './AppMenu';

import { HeaderMenuContext } from '../../pages';
import { MAIN_COLOR, WHITE_COLOR } from '../../constants';
import { faFilter } from '@fortawesome/fontawesome-free-solid/index';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const renderFilterMenu = fontColor => (
  <HeaderMenuContext.Consumer>
    {context =>
      context && (
        <SideMenuWrapper
          fontColor={fontColor}
          color={WHITE_COLOR}
          right={'80px'}
          crossButtonColor={MAIN_COLOR}
          customBurgerIcon={<StyledIcon color={fontColor} icon={faFilter} />}
        >
          {context.renderGameFilter}
        </SideMenuWrapper>
      )
    }
  </HeaderMenuContext.Consumer>
);

const SideMenu = ({ pathname, fontColor, toggle, selectedLang }) => (
  <Wrapper>
    {renderFilterMenu(fontColor)}

    <SideMenuWrapper fontColor={fontColor}>
      <AppMenu
        pathname={pathname}
        toggle={toggle}
        selectedLang={selectedLang}
      />
    </SideMenuWrapper>
  </Wrapper>
);

SideMenu.propTypes = {
  toggle: func.isRequired,
  selectedLang: shape({ value: string.isRequired, label: string.isRequired })
    .isRequired,
  pathname: string.isRequired,
  fontColor: string.isRequired,
};

export default SideMenu;



// WEBPACK FOOTER //
// components/SideMenu/index.js